import type { NotifyFn, NotifyOptions } from './useNotify'

/**
 * Imperative bridge so non-React callers (redux sagas, services) can raise a
 * notification — mirroring how `react-native-toast-message`'s `Toast.show`
 * worked. A single `<NotificationHost/>` mounted under the GluestackUIProvider
 * registers the live `notify` fn here; `notify()` proxies to it.
 */
let current: NotifyFn | null = null

export function registerNotify(fn: NotifyFn | null): void {
    current = fn
}

export function notify(opts: NotifyOptions): void {
    if (current) {
        current(opts)
    } else if (__DEV__) {
        // eslint-disable-next-line no-console
        console.warn(
            '[notify] called before <NotificationHost/> mounted — message dropped:',
            opts.message,
        )
    }
}
